module.exports = __webpack_public_path__ + "img/img-classify3.8256f738.png";